import { ISideBar } from "src/app/interface";

export class AuthModel {
    sideBar: ISideBar[] = [];
}